import { animated, config, useSpring } from '@react-spring/web';
import type { ReactElement } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  aspect-ratio: var(--card-aspect-ratio);
`;
const FrontWrapper = styled(animated.div)`
  position: absolute;
  inset: 0;
  clip-path: inset(0 0 calc(100% - var(--reveal-percent)) 0);
  pointer-events: none;
`;

export const RemainingCardRevealer = ({
  front,
  back,
  revealed,
  index,
  afterReveal,
  immediate,
}: {
  front: ReactElement;
  back: ReactElement;
  revealed: boolean;
  index: number;
  afterReveal: () => void;
  immediate: boolean;
}) => {
  const frontStyle = useSpring({
    y: revealed ? 0 : -10,
    opacity: revealed ? 1 : 0,
    config: config.stiff,
    delay: immediate ? 0 : index * 50,
    immediate,
    onRest: () => {
      if (revealed) {
        afterReveal();
      }
    },
  });
  const backStyle = useSpring({
    opacity: revealed ? 0 : 1,
    config: config.gentle,
  });

  return (
    <Wrapper>
      <animated.div style={backStyle}>{back}</animated.div>
      <FrontWrapper style={frontStyle}>{front}</FrontWrapper>
    </Wrapper>
  );
};
